<p-dialog [(visible)]="display" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['fad', 'comment-alt-edit']" class="me-4" size="lg"></fa-icon>
		FocusLink Release Notes
	</ng-template>
	<iframe width="100%" height="300" [src]="releaseNoteArticleUrl | safeUrl"></iframe>
	<ng-template pTemplate="footer">
		<div class="d-flex">
			<div class="ms-1">
				<a [href]="releaseNoteArticleUrl" target="_blank">View in a new tab</a>
			</div>
			<div class="ms-auto">
				<app-record-control-footer
					[hideDelete]="true"
					[hideSave]="true"
					(onCancelChange)="hideReleaseNoteChange.emit(true)"
				></app-record-control-footer>
			</div>
		</div>
	</ng-template>
</p-dialog>
